// EnergyBadge — Header badge showing energy score with color coding
import React from 'react';
import { useMind } from '../../../context/MindContext';
import { FaBolt } from 'react-icons/fa';

const COLOR_MAP = {
  green: { bg: 'bg-green-500/20', text: 'text-green-300', ring: 'ring-green-400/30' },
  yellow: { bg: 'bg-yellow-500/20', text: 'text-yellow-300', ring: 'ring-yellow-400/30' },
  red: { bg: 'bg-red-500/20', text: 'text-red-300', ring: 'ring-red-400/30' },
};

export default function EnergyBadge() {
  const { energyScore, energyLevel, isCheckedIn } = useMind();

  if (!isCheckedIn) return null;

  const colors = COLOR_MAP[energyLevel.color] || COLOR_MAP.yellow;
  const isLow = energyLevel.color === 'red';

  return (
    <div
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold ring-1 ${colors.bg} ${colors.text} ${colors.ring} ${
        isLow ? 'animate-pulse' : ''
      }`}
      title={`Energy: ${energyScore}/100 — ${energyLevel.label}`}
    >
      <FaBolt className="text-[9px]" />
      <span>{energyScore}</span>
    </div>
  );
}
